import { render, staticRenderFns } from "./product_search.vue?vue&type=template&id=1d22c884&scoped=true"
import script from "./product_search.vue?vue&type=script&lang=js"
export * from "./product_search.vue?vue&type=script&lang=js"
import style0 from "./product_search.vue?vue&type=style&index=0&id=1d22c884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22c884",
  null
  
)

export default component.exports